import React from 'react';
import CtaLink from '../Global/CtaLink';
//@ts-ignore
import * as styles from './ImageCopyBlock.module.css';
import { BuildLinkHref } from '../Global/BuildLinkHref';
import { graphql } from 'gatsby';
import {
    KontentStringValue,
    KontentRadioMultiChoice,
    KontentMedia,
    BrandColor,
    CTALocation,
    KontentNumberValue,
} from '../../../types/KontentProps';
import { getColor, getMediaData } from '../Global/DataUtils';
import RichText from '../Global/RichText';
import GatsbyImage from 'gatsby-image/withIEPolyfill';
import { getFluidImageData } from '../Global/DataUtils/gatsbyImageUtils';

type WindowAction = 'New Window' | 'Same Window';

interface Props extends KontentNumberValue {
    component_anchor_name: KontentStringValue;
    panels: {
        value: [
            {
                elements: {
                    content_panel__content_panel_color: BrandColor;
                    content_panel__content_panel_font_color: BrandColor;
                    description: KontentStringValue;
                    headline: KontentStringValue;
                    subheadline: KontentStringValue;
                    cta_configuration__cta_label: KontentStringValue;
                    cta_configuration__cta_location: CTALocation;
                    cta_configuration__cta_location_anchor_point: KontentStringValue;
                    cta_configuration__cta_window_action: KontentRadioMultiChoice<WindowAction>;
                    untitled_linked_items: KontentMedia;
                    hide_cta: {
                        value: [
                            {
                                codename: string;
                            }
                        ];
                    };
                };
            }
        ];
    };
}

const ImageCopyBlock: React.FC<Props> = ({ panels, component_anchor_name }) => {
    const backgroundColor = getColor(
        panels.value[0]?.elements?.content_panel__content_panel_color
    );
    const textColor = getColor(
        panels.value[0]?.elements?.content_panel__content_panel_font_color
    );
    const isbackgroundColor = backgroundColor ? backgroundColor : undefined;
    const istextColor = textColor ? textColor : undefined;
    const hideCta = panels.value[0]?.elements?.hide_cta?.value[0]?.codename;
    return (
        <div className={styles.main} id={component_anchor_name?.value}>
            {panels.value.map((tag: any, index) => {
                const image =
                    tag.elements?.untitled_linked_items &&
                    getFluidImageData(tag.elements.untitled_linked_items);

                return (
                    <div
                        className={styles.content}
                        key={index}
                        style={{
                            backgroundColor: isbackgroundColor,
                            color: istextColor,
                        }}
                    >
                        <div className={styles.halfheaderimage}>
                            {hideCta?.toLowerCase() !== 'yes' ? (
                                <div className={styles.imageCta}>
                                    <CtaLink
                                        href={
                                            tag.elements
                                                .cta_configuration__cta_location_anchor_point
                                                ?.value
                                                ? BuildLinkHref(
                                                      tag.elements
                                                          .cta_configuration__cta_location
                                                  ) +
                                                  '#' +
                                                  tag.elements
                                                      .cta_configuration__cta_location_anchor_point
                                                      ?.value
                                                : BuildLinkHref(
                                                      tag.elements
                                                          .cta_configuration__cta_location
                                                  )
                                        }
                                        target={
                                            tag.elements.ctaWindowAction ===
                                            'new_window'
                                                ? '_blank'
                                                : undefined
                                        }
                                        color={istextColor}
                                    >
                                        <GatsbyImage
                                            //@ts-ignore
                                            fluid={image?.source}
                                            alt={image?.alt}
                                        />
                                    </CtaLink>
                                </div>
                            ) : (
                                <GatsbyImage
                                    //@ts-ignore
                                    fluid={image?.source}
                                    alt={image?.alt}
                                    className={styles.image}
                                />
                            )}
                        </div>
                        <div className={styles.textContent}>
                            <div className={styles.heading}>
                                <h3>{tag.elements.headline.value}</h3>
                            </div>
                            {tag.elements?.subheadline?.value && (
                                <div className={styles.subheadline}>
                                    {tag.elements?.subheadline?.value}
                                </div>
                            )}
                            <div className={styles.para}>
                                {RichText(tag.elements.description)}
                            </div>
                            {hideCta?.toLowerCase() !== 'yes' && (
                                <div className={styles.cta}>
                                    <CtaLink
                                        href={
                                            tag.elements
                                                .cta_configuration__cta_location_anchor_point
                                                ?.value
                                                ? BuildLinkHref(
                                                      tag.elements
                                                          .cta_configuration__cta_location
                                                  ) +
                                                  '#' +
                                                  tag.elements
                                                      .cta_configuration__cta_location_anchor_point
                                                      ?.value
                                                : BuildLinkHref(
                                                      tag.elements
                                                          .cta_configuration__cta_location
                                                  )
                                        }
                                        target={
                                            tag.elements.ctaWindowAction ===
                                            'new_window'
                                                ? '_blank'
                                                : undefined
                                        }
                                        color={istextColor}
                                    >
                                        {
                                            tag.elements
                                                .cta_configuration__cta_label
                                                ?.value
                                        }
                                    </CtaLink>
                                </div>
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default ImageCopyBlock;

export const fragmentImageCopyBlock = graphql`
    fragment ImageCopyBlock on kontent_item_component___half_image_copy_block_a9f8fc6 {
        elements {
            component_anchor_name {
                value
            }
            panels {
                value {
                    ... on kontent_item_content_item___general_structured_panel__copy_ {
                        id
                        elements {
                            headline {
                                value
                            }
                            subheadline {
                                value
                            }
                            hide_cta {
                                value {
                                    codename
                                }
                            }
                            content_panel__content_panel_color {
                                value {
                                    ... on kontent_item_list___brand_colors {
                                        id
                                        elements {
                                            color_hex_value {
                                                value
                                            }
                                        }
                                    }
                                }
                            }
                            content_panel__content_panel_font_color {
                                value {
                                    ... on kontent_item_list___brand_colors {
                                        id
                                        elements {
                                            color_hex_value {
                                                value
                                            }
                                        }
                                    }
                                }
                            }
                            cta_configuration__cta_label {
                                value
                            }
                            cta_configuration__cta_location {
                                ...kontentCtaLocation
                            }
                            cta_configuration__cta_location_anchor_point {
                                value
                            }
                            cta_configuration__cta_window_action {
                                value {
                                    codename
                                }
                            }
                            description {
                                links {
                                    codename
                                }
                                images {
                                    url
                                }
                                value
                            }
                            untitled_linked_items {
                                value {
                                    ... on kontent_item_media___image {
                                        id
                                        elements {
                                            file {
                                                value {
                                                    url
                                                    description
                                                    name
                                                    fluid(
                                                        maxWidth: 720
                                                        maxHeight: 520
                                                        quality: 100
                                                    ) {
                                                        ...KontentAssetFluid
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;
